import React from "react";
import CrudManager from "../components/CrudManager";
import { api } from "../../lib/api";

const sections = ["Header", "Highlights", "Contact", "School Details", "Facilities", "Infrastructure", "Enrollment", "Teachers", "Management"];
const fields = [
  { name: "section", label: "Section", type: "select", options: sections, defaultValue: "School Details", required: true },
  { name: "label", label: "Label", required: true },
  { name: "value", label: "Value", type: "textarea", rows: 2, required: true, fullWidth: true },
  { name: "position", label: "Display Position", type: "number", defaultValue: 0, min: 0 },
  { name: "isActive", label: "Detail Status", type: "checkbox", defaultValue: true, help: "Show on website" },
];

export default function CbseDetails() {
  return <CrudManager title="CBSE Details" singular="CBSE Detail" fields={fields} apiResource={api.cbseDetails} columns={[
    { label: "Section", accessor: "section" },
    { label: "Label", accessor: "label" },
    { label: "Value", render: (item) => <div className="admin-message-cell">{item.value}</div> },
    { label: "Position", accessor: "position" },
    { label: "Status", render: (item) => <span className={`admin-badge ${item.isActive ? "success" : "muted"}`}>{item.isActive ? "Active" : "Hidden"}</span> },
  ]} />;
}
